import { useNavigate } from "react-router";
import Box from '@mui/material/Box';
import * as theme from '../theme';
import CostContext, { formatCentsToDollarsNoDecimal } from "../contexts/CostContext";

const PricingCard = () => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate('/enroll')}
      sx={{
        backgroundColor: theme.Colors.GrayDark,
        border: `9px solid ${theme.Colors.Gold}`,
        borderRadius: '10px',
        padding: '20px',
        textAlign: 'center',
        maxWidth: 338,
        height: 245,
        boxSizing: 'border-box',
        margin: '0 auto',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: theme.Colors.Purple, // Optional hover effect
        },
      }}
    >
      <h3
        style={{
          color: theme.Colors.White,
          fontSize: 18,
          fontWeight: 700,
          letterSpacing: 3.6,
          textTransform: 'uppercase',
          margin: '0 0 20px 0',
        }}
      >
        Lifetime Access
      </h3>
      <h1
        style={{
          color: theme.Colors.Gold,
          fontSize: 74,
          fontWeight: 700,
          letterSpacing: 14.8,
          margin: '0',
        }}
      >
        ${formatCentsToDollarsNoDecimal(CostContext.SubscriptionAmount)}
      </h1>
      <h3
        style={{
          color: theme.Colors.White,
          fontSize: 16,
          letterSpacing: 1.6,
          fontWeight: 300,
          textTransform: 'uppercase',
          margin: '20px 0 15px 0',
        }}
      >
        Pre-Launch Special
      </h3>
    </Box>
  );
};

export default PricingCard;